export const PROJECT_COLORS = [
  { value: '#1976d2', label: 'Bleu' },
  { value: '#388e3c', label: 'Vert' },
  { value: '#d32f2f', label: 'Rouge' },
  { value: '#f57c00', label: 'Orange' },
  { value: '#7b1fa2', label: 'Violet' },
  { value: '#0097a7', label: 'Cyan' },
  { value: '#c2185b', label: 'Rose' },
  { value: '#5d4037', label: 'Marron' },
  { value: '#455a64', label: 'Gris Bleu' },
  { value: '#00796b', label: 'Teal' },
  { value: '#e64a19', label: 'Orange foncé' },
  { value: '#303f9f', label: 'Indigo' }
];

export const getRandomProjectColor = () => {
  const randomIndex = Math.floor(Math.random() * PROJECT_COLORS.length);
  return PROJECT_COLORS[randomIndex].value;
};

export const getProjectColorLabel = (colorValue) => {
  const color = PROJECT_COLORS.find(c => c.value === colorValue);
  return color ? color.label : 'Couleur personnalisée';
};
